import axios from '../axiosInstance';

/** INI_TABLE.CODE for the default site used on load create / booking. */
export const DEFAULT_SITE_INI_CODE = 'SiteId';

/** Session-long cache key — never invalidated; only refetched after a hard page refresh. */
export const DEFAULT_SITE_ID_QUERY_KEY = ['iniTable', 'defaultSiteId'];

/**
 * @param {number} id - INI_TABLE_ID
 * @returns {Promise<{ id: number, section: string, code: string, codeValue: string }>}
 */
export async function getIniTableById(id, signal = null) {
  const { data } = await axios.get(`/IniTable/${id}`, { signal });
  return data;
}

/**
 * @param {string} code - INI_TABLE.CODE
 * @returns {Promise<{ id: number, section: string, code: string, codeValue: string }>}
 */
export async function getIniTableByCode(code, signal = null) {
  const { data } = await axios.get(`/IniTable/byCode/${encodeURIComponent(code)}`, { signal });
  return data;
}

/**
 * Resolve siteId from INI_TABLE where CODE = 'SiteId' (CODE_VALUE).
 * @returns {Promise<number>}
 */
export async function fetchDefaultSiteId(signal = null) {
  const row = await getIniTableByCode(DEFAULT_SITE_INI_CODE, signal);
  const siteId = Number(row?.codeValue ?? row?.CodeValue);
  if (!Number.isFinite(siteId) || siteId <= 0) {
    throw new Error("Default site is not configured in INI_TABLE (CODE = 'SiteId').");
  }
  return siteId;
}

/** @deprecated Use fetchDefaultSiteId / DEFAULT_SITE_ID_QUERY_KEY */
export async function getBookingFormSiteId(signal = null) {
  return fetchDefaultSiteId(signal);
}

/** React Query options: fetch once per browser session (hard refresh clears cache). */
export const defaultSiteIdQueryOptions = {
  queryKey: DEFAULT_SITE_ID_QUERY_KEY,
  queryFn: ({ signal }) => fetchDefaultSiteId(signal),
  staleTime: Infinity,
  gcTime: Infinity,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};
